export { DictionaryController } from './dictionaryController';
export { dictionaryResolverFs } from './dictionaryResolverFs';
